import './entity-list.scss';

import { EntityDataStore } from '@skinsoft/entity-data-store';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { EntityFeaturedList, EntityHistory, Featured } from '@skinsoft/ui';
import { Component } from 'vue-property-decorator';

import { Container, Movement, MovementDataStore, MovementTypes, Task } from '@skinsoft/entity';
import { CREATE_CONTAINER_TOPIC, CREATE_MOVEMENT_TOPIC, CREATE_SIMPLE_MOVEMENT_TOPIC } from '../../../busTopics';
import { router, Routes } from '../../../router';
import { CreateMovementModal } from '../../component/create-movement-modal';
import { CreateContainerModal } from '../../component/create-container-modal';

@Component({
    components: {
        sCreateMovementModal: CreateMovementModal,
        sCreateContainerModal: CreateContainerModal
    },
    props: ['entityDataStore', 'entityFeaturedList', 'entityHistory', 'targetRouteName'],
    template: require('./entity-list.html'),
})
export class EntityList extends ReactiveVue {
    public entityDataStore: EntityDataStore<any>;
    public entityFeaturedList: EntityFeaturedList<Task | Movement | Container>;
    public entityHistory: EntityHistory<Task | Movement>;
    public targetRouteName: string;

    public featureds: Array<Featured | null> = [];
    public items: Featured[] = [];

    public $refs: {
        createMovementModal: CreateMovementModal;
        createContainerModal: CreateContainerModal;
    };

    public created() {
        this.subscribeToBus(CREATE_MOVEMENT_TOPIC, this.onCreateMovement.bind(this, MovementTypes.COMPLEX));
        this.subscribeToBus(CREATE_SIMPLE_MOVEMENT_TOPIC, this.onCreateMovement.bind(this, MovementTypes.SIMPLE))
        this.subscribeToBus(CREATE_CONTAINER_TOPIC, this.onCreateContainer.bind(this))
    }

    private onCreateMovement(movementType = MovementTypes.COMPLEX) {
        this.$refs.createMovementModal.open(movementType);
    }

    private onCreateContainer() {
        this.$refs.createContainerModal.open()
    }
}
